/**
 * Grade 10 — 34 questions, A–D (same structure as sheet / scoring).
 * Edit this file for Class 10 wording; other grades start as copies in 9/11/12 until you replace them.
 */
export const RAW = [
  [
    "When something does not make sense in class… What do you do?",
    [
      "🧠 I try to understand the logic behind it",
      "🎨 I think of different ways it could work",
      "👥 I ask someone to explain",
      "⏭️ I move ahead for now",
    ],
  ],
  [
    "You are stuck on a difficult question. What is your approach?",
    ["🧩 Break it into smaller steps", "🎯 Try different methods until something works", "👥 Look for help or examples", "⏸️ Leave it for later"],
  ],
  [
    "Which type of tasks do you enjoy most?",
    ["🧠 Tasks with clear logic and structure", "🎨 Tasks where I can think freely and explore", "👥 Tasks involving discussion", "⚡ Quick and simple tasks"],
  ],
  [
    "When learning something new, you prefer:",
    ["📘 Step-by-step explanation", "🧪 Experimenting and figuring it out", "👥 Learning with others", "⏭️ Learning only what is necessary"],
  ],
  [
    "You feel most confident when:",
    ["🧠 You fully understand something", "🎨 You come up with unique ideas", "👥 You have support from others", "😌 You avoid difficult situations"],
  ],
  [
    "When faced with multiple options, you:",
    ["🧠 Analyze all possibilities", "🎯 Choose what feels interesting", "👥 Ask others for suggestions", "⏸️ Delay or choose quickly"],
  ],
  [
    "You prefer questions that:",
    ["🎯 Have one correct answer", "🎨 Allow multiple creative answers", "👥 Can be discussed", "⚡ Are simple and direct"],
  ],
  [
    "Your study style is usually:",
    ["📅 Planned and scheduled", "🌊 Flexible, depending on mood", "👥 Group study or discussion", "⏳ Last-minute"],
  ],
  [
    "When you have a deadline:",
    ["🧠 I start early and plan ahead", "⚡ I work in phases or bursts", "👥 I coordinate with others", "⏳ I complete it at the last moment"],
  ],
  [
    "You prefer working:",
    ["📘 With clear instructions", "🎨 With freedom and flexibility", "👥 With a team", "⏭️ Only when necessary"],
  ],
  [
    "Your notes are generally:",
    ["📚 Organized and structured", "🌀 Unstructured but meaningful to me", "👥 Shared or discussed with others", "😅 Incomplete"],
  ],
  [
    "When things get messy, you:",
    ["🧠 I try to organize them", "🌊 I adjust and continue", "👥 I ask for help", "⏭️ I leave it"],
  ],
  [
    "You prefer tasks that are:",
    ["🧩 Structured", "🎨 Open-ended", "👥 Collaborative", "⚡ Low effort"],
  ],
  [
    "How do you manage your time?",
    ["📅 Plan in advance", "🌊 Go with the flow", "👥 Align with others", "⏳ Focus only when urgent"],
  ],
  [
    "In group projects, you usually:",
    ["🧠 Plan and organize", "🎨 Contribute ideas", "👥 Communicate and coordinate", "⏭️ Stay in the background"],
  ],
  [
    "During discussions, you:",
    ["📊 Focus on facts", "🎨 Share creative perspectives", "👥 Engage actively", "⏭️ Prefer not to speak"],
  ],
  [
    "You feel most comfortable when:",
    ["🧠 Working independently", "🎨 Exploring ideas", "👥 Being around people", "😌 Having no pressure"],
  ],
  [
    "When someone needs help, you:",
    ["🧠 Solve logically", "🎨 Suggest ideas", "❤️ Offer emotional support", "⏭️ Prefer not to get involved"],
  ],
  [
    "You prefer teachers who:",
    ["📘 Explain clearly", "🎨 Encourage creativity", "👥 Are interactive", "😌 Maintain a low-pressure environment"],
  ],
  [
    "In social situations, you:",
    ["👀 Observe and analyze", "🎤 Express your ideas", "👥 Interact easily", "⏭️ Stay reserved"],
  ],
  [
    "You make decisions based on:",
    ["🧠 Logic", "🎯 Ideas or instinct", "👥 Others opinions", "⚠️ Avoiding risk"],
  ],
  [
    "When starting something new:",
    ["📅 I plan first", "⚡ I begin immediately", "👥 I ask for guidance", "⏳ I delay"],
  ],
  [
    "When you face failure:",
    ["🧠 Analyze what went wrong", "🎯 Try again differently", "👥 Talk to someone", "⏭️ Avoid trying again"],
  ],
  [
    "Your biggest challenge is:",
    ["🧠 Overthinking", "📱 Distraction", "👥 Dependence on others", "⏳ Procrastination"],
  ],
  [
    "When work piles up:",
    ["📅 Prioritize tasks", "⚡ Do what I can randomly", "👥 Ask for help", "⏳ Ignore for some time"],
  ],
  [
    "You usually complete tasks:",
    ["🧩 Systematically", "⚡ In bursts", "👥 With support", "⏳ At the last moment"],
  ],
  [
    "Your motivation comes from:",
    ["🎯 Clarity", "🔥 Interest", "👥 People", "⚡ Pressure"],
  ],
  [
    "Under pressure, you:",
    ["🧠 Plan and organize", "⚡ Take action", "👥 Share with others", "⏭️ Avoid"],
  ],
  [
    "You are naturally drawn to:",
    ["🧠 Solving problems", "🎨 Creating new ideas", "👥 Working with people", "😌 Relaxing"],
  ],
  [
    "You enjoy:",
    ["🧩 Logical tasks", "🎨 Creative tasks", "👥 Social activities", "⚡ Simple tasks"],
  ],
  [
    "Subjects you prefer:",
    ["📊 Math / Science", "🎨 Arts", "📖 Humanities", "😅 Basic or passable subjects"],
  ],
  [
    "In your free time, you usually:",
    ["📚 Learn something new", "🎨 Create something", "👥 Spend time with people", "📱 Relax or scroll"],
  ],
  [
    "You feel most satisfied when:",
    ["🧠 You solve something", "🎨 You create something", "❤️ You connect with people", "😌 You feel relaxed"],
  ],
  [
    "You want your future work to be:",
    ["📅 Stable and structured", "🚀 Innovative and flexible", "👥 People-oriented", "😌 Low pressure"],
  ],
];
